import React from 'react'
import Contract from './Contract';
export default function ParentContract() {
    return (
        <Contract />
    )
}